import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Loading2, SwyftxFull } from '@swyftx/aviary/icons/outlined';

import { useLayoutStore } from '../hooks';

const SwyftxPlatformLoader: React.FC = () => {
  const { switchPlatform } = useLayoutStore();
  const { t } = useTranslation('common');

  if (!switchPlatform) return null;

  return (
    <FlexLayout
      className='fixed z-modal-popover h-full w-full bg-color-background-surface-primary'
      alignItems='center'
      justifyContent='center'
      direction='column'
      spacing={16}
    >
      <FlexLayout className='h-full w-full' spacing={16} direction='column' alignItems='center' justifyContent='center'>
        <Loading2 width={48} height={48} className='h-48 w-48 animate-spin text-color-text-primary will-change-auto' />
        <FlexLayout
          className='w-full translate-y-[15%] animate-loading-platform-in opacity-0 will-change-auto delay-1000'
          direction='column'
          alignItems='center'
          justifyContent='center'
          spacing={4}
        >
          <SwyftxFull className='w-1/2 max-w-[172px] text-color-text-primary' />
          <span className='font-callout text-24 text-color-text-accent'>{t(`platform.${switchPlatform}`)}</span>
        </FlexLayout>
      </FlexLayout>
    </FlexLayout>
  );
};

export { SwyftxPlatformLoader };
10;
